// Recovered compiled webpack factory 75784. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  let n, a, o, i, s;
  r.d(t, { a9: () => $, hT: () => q, Pt: () => B, wv: () => Y, YG: () => z, tC: () => ee });
  var l = r(43275),
    u = r(85236),
    c = r(96812),
    f = r(38599);
  let d = (e, t, r, n) => {
    let a, o;
    return (i) => {
      t.value >= 0 &&
        (i || n) &&
        ((o = t.value - (a ?? 0)) || void 0 === a) &&
        ((a = t.value),
        (t.delta = o),
        (t.rating = ((e, t) => (e > t[1] ? "poor" : e > t[0] ? "needs-improvement" : "good"))(
          t.value,
          r,
        )),
        e(t));
    };
  };
  var p = r(14231),
    h = r(32191),
    _ = r(23989);
  let m = (e, t = -1) => {
      let r = (0, _.z)(),
        n = "navigate";
      return (
        r &&
          (f.j.document?.prerendering || (0, h.b)() > 0
            ? (n = "prerender")
            : f.j.document?.wasDiscarded
              ? (n = "restore")
              : r.type && (n = r.type.replace(/_/g, "-"))),
        {
          name: e,
          value: t,
          rating: "good",
          delta: 0,
          entries: [],
          id: `v5-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`,
          navigationType: n,
        }
      );
    },
    g = new WeakMap();
  function y(e, t) {
    try {
      return (g.get(e) || g.set(e, new t()), g.get(e));
    } catch (e) {
      return new t();
    }
  }
  class v {
    constructor() {
      (v.prototype.__init.call(this), v.prototype.__init2.call(this));
    }
    __init() {
      this._sessionValue = 0;
    }
    __init2() {
      this._sessionEntries = [];
    }
    _processEntry(e) {
      if (e.hadRecentInput) return;
      let t = this._sessionEntries[0],
        r = this._sessionEntries[this._sessionEntries.length - 1];
      (this._sessionValue &&
      t &&
      r &&
      e.startTime - r.startTime < 1e3 &&
      e.startTime - t.startTime < 5e3
        ? ((this._sessionValue += e.value), this._sessionEntries.push(e))
        : ((this._sessionValue = e.value), (this._sessionEntries = [e])),
        this._onAfterProcessingUnexpectedShift?.(e));
    }
  }
  let b = (e, t, r = {}) => {
      try {
        if (PerformanceObserver.supportedEntryTypes.includes(e)) {
          let n = new PerformanceObserver((e) => {
            Promise.resolve().then(() => {
              t(e.getEntries());
            });
          });
          return (n.observe({ type: e, buffered: !0, ...r }), n);
        }
      } catch {}
    },
    E = (e) => {
      let t = !1;
      return () => {
        t || (e(), (t = !0));
      };
    },
    R = (e) => {
      f.j.document?.prerendering ? addEventListener("prerenderingchange", () => e(), !0) : e();
    },
    P = [1800, 3e3],
    S = [0.1, 0.25],
    O = 0,
    T = 1 / 0,
    w = 0,
    j = (e) => {
      e.forEach((e) => {
        e.interactionId &&
          ((T = Math.min(T, e.interactionId)),
          (O = (w = Math.max(w, e.interactionId)) ? (w - T) / 7 + 1 : 0));
      });
    },
    x = () => (n ? O : performance.interactionCount || 0),
    A = 0;
  class C {
    constructor() {
      (C.prototype.__init.call(this), C.prototype.__init2.call(this));
    }
    __init() {
      this._longestInteractionList = [];
    }
    __init2() {
      this._longestInteractionMap = new Map();
    }
    _resetInteractions() {
      ((A = x()), (this._longestInteractionList.length = 0), this._longestInteractionMap.clear());
    }
    _estimateP98LongestInteraction() {
      let e = Math.min(this._longestInteractionList.length - 1, Math.floor((x() - A) / 50));
      return this._longestInteractionList[e];
    }
    _processEntry(e) {
      if ((this._onBeforeProcessingEntry?.(e), !(e.interactionId || "first-input" === e.entryType)))
        return;
      let t = this._longestInteractionList.at(-1),
        r = this._longestInteractionMap.get(e.interactionId);
      if (r || this._longestInteractionList.length < 10 || e.duration > t._latency) {
        if (
          (r
            ? e.duration > r._latency
              ? ((r.entries = [e]), (r._latency = e.duration))
              : e.duration === r._latency &&
                e.startTime === r.entries[0].startTime &&
                r.entries.push(e)
            : ((r = { id: e.interactionId, entries: [e], _latency: e.duration }),
              this._longestInteractionMap.set(r.id, r),
              this._longestInteractionList.push(r)),
          this._longestInteractionList.sort((e, t) => t._latency - e._latency),
          this._longestInteractionList.length > 10)
        )
          for (let e of this._longestInteractionList.splice(10))
            this._longestInteractionMap.delete(e.id);
        this._onAfterProcessingINPCandidate?.(r);
      }
    }
  }
  var M = r(36825);
  let N = (e) => {
      let t = f.j.requestIdleCallback || f.j.setTimeout;
      f.j.document?.visibilityState === "hidden"
        ? e()
        : ((e = E(e)),
          (0, M.d)("visibilitychange", e, { once: !0, capture: !0 }),
          (0, M.d)("pagehide", e, { once: !0, capture: !0 }),
          t(() => {
            (e(),
              (0, M.Q)("visibilitychange", e, { capture: !0 }),
              (0, M.Q)("pagehide", e, { capture: !0 }));
          }));
    },
    k = [200, 500];
  class I {
    _processEntry(e) {
      this._onBeforeProcessingEntry?.(e);
    }
  }
  let L = [2500, 4e3],
    D = [800, 1800],
    U = (e) => {
      f.j.document?.prerendering
        ? R(() => U(e))
        : f.j.document?.readyState !== "complete"
          ? addEventListener("load", () => U(e), !0)
          : setTimeout(e);
    },
    H = {},
    F = {};
  function $(e, t = !1) {
    return J("cls", e, W, a, t);
  }
  function B(e, t = !1) {
    return J("lcp", e, K, o, t);
  }
  function z(e) {
    return J("ttfb", e, G, i);
  }
  function q(e) {
    return J("inp", e, V, s);
  }
  function Y(e, t) {
    return (
      Q(e, t),
      F[e] ||
        ((function (e) {
          let t = {};
          ("event" === e && (t.durationThreshold = 0),
            b(
              e,
              (t) => {
                X(e, { entries: t });
              },
              t,
            ));
        })(e),
        (F[e] = !0)),
      Z(e, t)
    );
  }
  function X(e, t) {
    let r = H[e];
    if (r?.length)
      for (let n of r)
        try {
          n(t);
        } catch (t) {
          c.T &&
            l.Yz.error(
              `Error while triggering instrumentation handler.
Type: ${e}
Name: ${(0, u.qQ)(n)}
Error:`,
              t,
            );
        }
  }
  function W() {
    return ((e, t = {}) => {
      ((e, t = {}) => {
        R(() => {
          let r,
            n = (0, p.N)(),
            a = m("FCP"),
            o = b("paint", (e) => {
              for (let t of e)
                "first-contentful-paint" === t.name &&
                  (o.disconnect(),
                  t.startTime < n.firstHiddenTime &&
                    ((a.value = Math.max(t.startTime - (0, h.b)(), 0)), a.entries.push(t), r(!0)));
            });
          o && (r = d(e, a, P, t.reportAllChanges));
        });
      })(
        E(() => {
          let r,
            n = m("CLS", 0),
            a = (0, p.N)(),
            o = y(t, v),
            i = (e) => {
              for (let t of e) o._processEntry(t);
              o._sessionValue > n.value &&
                ((n.value = o._sessionValue), (n.entries = o._sessionEntries), r());
            },
            s = b("layout-shift", i);
          s &&
            ((r = d(e, n, S, t.reportAllChanges)),
            a.onHidden(() => {
              (i(s.takeRecords()), r(!0));
            }),
            f.j?.setTimeout?.(r));
        }),
      );
    })(
      (e) => {
        (X("cls", { metric: e }), (a = e));
      },
      { reportAllChanges: !0 },
    );
  }
  function K() {
    return ((e, t = {}) => {
      R(() => {
        let r,
          n = (0, p.N)(),
          a = m("LCP"),
          o = y(t, I),
          i = (e) => {
            for (let i of (t.reportAllChanges || (e = e.slice(-1)), e))
              (o._processEntry(i),
                i.startTime < n.firstHiddenTime &&
                  ((a.value = Math.max(i.startTime - (0, h.b)(), 0)), (a.entries = [i]), r()));
          },
          s = b("largest-contentful-paint", i);
        if (s) {
          r = d(e, a, L, t.reportAllChanges);
          let n = E(() => {
              (i(s.takeRecords()), s.disconnect(), r(!0));
            }),
            o = (e) => {
              e.isTrusted && (N(n), (0, M.Q)(e.type, o, { capture: !0 }));
            };
          for (let e of ["keydown", "click", "visibilitychange"]) (0, M.d)(e, o, { capture: !0 });
        }
      });
    })(
      (e) => {
        (X("lcp", { metric: e }), (o = e));
      },
      { reportAllChanges: !0 },
    );
  }
  function G() {
    return ((e, t = {}) => {
      let r = m("TTFB"),
        n = d(e, r, D, t.reportAllChanges);
      U(() => {
        let e = (0, _.z)();
        e && ((r.value = Math.max(e.responseStart - (0, h.b)(), 0)), (r.entries = [e]), n(!0));
      });
    })((e) => {
      (X("ttfb", { metric: e }), (i = e));
    });
  }
  function V() {
    return ((e, t = {}) => {
      if (
        !(globalThis.PerformanceEventTiming && "interactionId" in PerformanceEventTiming.prototype)
      )
        return;
      let r = (0, p.N)();
      R(() => {
        let a;
        "interactionCount" in performance ||
          n ||
          (n = b("event", j, { type: "event", buffered: !0, durationThreshold: 0 }));
        let o = m("INP"),
          i = y(t, C),
          s = (e) => {
            N(() => {
              for (let t of e) i._processEntry(t);
              let t = i._estimateP98LongestInteraction();
              t && t._latency !== o.value && ((o.value = t._latency), (o.entries = t.entries), a());
            });
          },
          l = b("event", s, { durationThreshold: t.durationThreshold ?? 40 });
        ((a = d(e, o, k, t.reportAllChanges)),
          l &&
            (l.observe({ type: "first-input", buffered: !0 }),
            r.onHidden(() => {
              (s(l.takeRecords()), a(!0));
            })));
      });
    })((e) => {
      (X("inp", { metric: e }), (s = e));
    });
  }
  function J(e, t, r, n, a = !1) {
    let o;
    return (
      Q(e, t),
      F[e] || ((o = r()), (F[e] = !0)),
      n && t({ metric: n }),
      Z(e, t, a ? o : void 0)
    );
  }
  function Q(e, t) {
    ((H[e] = H[e] || []), H[e].push(t));
  }
  function Z(e, t, r) {
    return () => {
      r && r();
      let n = H[e];
      if (!n) return;
      let a = n.indexOf(t);
      -1 !== a && n.splice(a, 1);
    };
  }
  function ee(e) {
    return "duration" in e;
  }
}
